'use client';

import clsx from 'clsx';
import { DallasList, DallasListItem } from '@ui/Dallas/List/DallasList';
import DallasCard from '@ui/Dallas/Card/DallasCard';
import DallasStack from '@ui/Dallas/Stack/DallasStack';
import DallasSkeleton from '@ui/Dallas/Skeleton/DallasSkeleton';
import DallasTextSkeleton from '@ui/Dallas/Text/DallasTextSkeleton';

import styles from './LoadGridListSkeleton.module.scss';

export const DEFAULT_ITEM_COUNT = 6;

interface Props {
  className?: string;
  itemCount?: number;
}

export default function LoadGridListSkeleton({
  className,
  itemCount = DEFAULT_ITEM_COUNT,
}: Props) {
  const emptyItems = Array.from({ length: itemCount });

  return (
    <DallasList
      className={clsx(className, styles.root)}
      data={emptyItems}
      hasMoreItems={false}
      listItemTemplate={() => <LoadGridListItemSkeleton />}
    />
  );
}

export function LoadGridListItemSkeleton() {
  return (
    <DallasListItem className={styles.listItem}>
      <LoadCardSkeleton />
    </DallasListItem>
  );
}

function LoadCardSkeleton() {
  return (
    <DallasCard
      className={styles.card}
      gap="md"
      header={
        <header className={styles.header}>
          <DallasStack
            className={styles.priceRow}
            gap="sm"
            direction="row"
            alignVertical="center"
            flex
          >
            <DallasTextSkeleton variant="headerBoldS" />
            <DallasTextSkeleton />
          </DallasStack>
          <DallasSkeleton variant="semi-rounded" />
        </header>
      }
      content={
        <DallasStack className={styles.tagsContainer} gap="xs" direction="row">
          <DallasSkeleton variant="semi-rounded" width={50} />
          <DallasSkeleton variant="semi-rounded" width={200} />
          <DallasSkeleton variant="semi-rounded" width={60} />
        </DallasStack>
      }
      footer={
        <div className={styles.footer}>
          <DallasStack className={styles.stopsSummary} gap="2xs" flex>
            <DallasStack gap="xs" direction="row" alignVertical="center">
              <DallasSkeleton
                className={styles.pickupIndicator}
                variant="circular"
              />
              <DallasTextSkeleton variant="captionL" fullLine />
            </DallasStack>
            <DallasStack gap="xs" direction="row" alignVertical="center">
              <DallasSkeleton className={styles.deliveryIndicator} />
              <DallasTextSkeleton variant="captionL" fullLine />
            </DallasStack>
          </DallasStack>
          <DallasTextSkeleton className={styles.age} variant="captionL" />
        </div>
      }
      bordered
    />
  );
}
